import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-type-service";

export const pagingPatientTypeService = (obj) =>
  axios.post(API_PATH + "/search-by-page", obj);

export const getPatientTypeServiceById = (patientTypeServiceId) =>
  axios.get(API_PATH + "/get-by-id/" + patientTypeServiceId);

export const savePatientTypeService = (patientTypeService) =>
  axios.post(API_PATH + "/save-or-update", patientTypeService);

export const deletePatientTypeService = (patientTypeServiceId) =>
  axios.delete(API_PATH + "/mark-delete/" + patientTypeServiceId);

export const getAllPatientTypeService = () => axios.get(API_PATH + "/get-all");

export const syncPatientTypeService = (obj) =>
  axios.post(API_PATH + "/sync-patient-type-service", obj);
